export enum ReportEntryEvents {
  FeaturedReportClicked = "Report Library Entry: Featured Report Clicked",
  HorizontalCardClicked = "Report Library Entry: Horizontal Card Clicked",
  HorizontalNavClicked = "Report Library Entry: Horizontal Navigation Clicked",
  RecentlyPublishedLinkClicked = "Report Library Entry: Recently Published Link Clicked",
  RecentlyPublishedTabClicked = "Report Library Entry: Recently Published Tab Clicked",
  TabbedReportTabClicked = "Report Library Entry: Tabbed Reports Tab Cicked",
  TabbedReportLinkClicked = "Report Library Entry: Tabbed Reports Link Clicked",
  TrialCtaClicked = "Report Library Entry: Trial CTA Clicked",
}
